document.addEventListener('DOMContentLoaded', () => {
    const navBtn = document.querySelector('#mobile-nav-btn');
    const navBackdrop = document.querySelector('#nav-backdrop');
    let isOpen = false;

    const openNav = () => {
        isOpen = true;
        navBtn.classList.add('active');
        navBackdrop.classList.add('show');
        navBtn.setAttribute('aria-label', 'mobile menu close');
        document.body.style.overflow = 'hidden'; // Prevent scrolling when nav is open
    };

    const closeNav = () => {
        isOpen = false;
        navBtn.classList.remove('active');
        navBackdrop.classList.remove('show');
        navBtn.setAttribute('aria-label', 'mobile menu open');
        document.body.style.overflow = ''; // Restore scrolling
    };

    navBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (isOpen) {
            closeNav();
        } else {
            openNav();
        }
    });

    navBackdrop.addEventListener('click', (e) => {
        if (e.target === navBackdrop) {
            closeNav();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) {
            closeNav();
        }
    });
});
